import moment from 'moment-timezone';
import { eventGenderTypeIds } from '../../../../../utils/eventConstants';

const genderFilterMap = {
    'Co-ed': eventGenderTypeIds.ALL,
    M: eventGenderTypeIds.MALE,
    F: eventGenderTypeIds.FEMALE,
    Mixed: eventGenderTypeIds.MIXED,
};

export const matchesGenderFilter = (genderId, gender) => genderId === genderFilterMap[gender];

const isAgeEligible = (division, age) => age <= division.maxAge && age >= division.minAge;

const isRatingEligible = (division, rating) => rating <= division.maxUtr && rating >= division.minUtr;

const isInDateRange = (divisionDate, startDate, endDate) => divisionDate.isSameOrAfter(startDate, 'day') && divisionDate.isSameOrBefore(endDate, 'day');

const hasDivisionTypeFilter = (divisionTypes) => divisionTypes && Object.values(divisionTypes).some(v => v);

export const filterDivision = (division, filters, timeZone) => {
    if (division.isEventEntryFeeDivision) {
        return false;
    }
    if (filters.gender && !matchesGenderFilter(division.genderId, filters.gender)) {
        return false;
    }
    if (filters.age && !isAgeEligible(division, filters.age)) {
        return false;
    }
    const divisionDate = division.specificDivisionDateUtc
        ? moment.utc(division.specificDivisionDateUtc).tz(timeZone?.value)
        : null;
    if (divisionDate && filters.startDate && filters.endDate && !isInDateRange(divisionDate, filters.startDate, filters.endDate)) {
        return false;
    }
    if (hasDivisionTypeFilter(filters.divisionTypes) && !filters.divisionTypes[division.divisionFormatTypeId]) {
        return false;
    }
    if (filters.rating && !isRatingEligible(division, filters.rating)) {
        return false;
    }
    return true;
};
